import React from 'react';
import { credentials, education, skillGroups } from '../../data/portfolio';
import './Skills.css';

function Skills() {
  return (
    <section id="skills" className="skills-section" aria-label="기술">
      <div className="section-heading">
        <p>Skills & credentials</p>
        <h2 id="skills-title">기술과 자격</h2>
      </div>

      <div className="skills-content">
        <div className="skill-groups">
          {skillGroups.map((group) => (
            <article key={group.id}>
              <h3>{group.title}</h3>
              <p>{group.items.join(' · ')}</p>
            </article>
          ))}
        </div>

        <div className="credentials-column">
          <div>
            <h3>자격</h3>
            <ul>
              {credentials.map((credential) => (
                <li key={credential.id}>
                  <strong>{credential.title}</strong>
                  <span>{credential.date}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3>교육</h3>
            <ul>
              {education.map((item) => (
                <li key={item.id}>
                  <strong>{item.title}</strong>
                  {item.date && <span>{item.date}</span>}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
